import palette from '@lib/core/src/theme/palette';
import { Stack } from '@mui/material';

import { CalendarMeetingDto } from '@/api/generated';
import { getHoursAndMinutesFromNumberOfSeconds } from '@/utils/dateUtil';

import { MeetingTopic } from './MeetingOverview/MeetingOverviewStyles';

const MeetingTopics = ({
  meeting,
  onTimeClicked
}: {
  meeting: CalendarMeetingDto | undefined;
  onTimeClicked: (time: number) => void;
}) => (
  <Stack gap="24px">
    {meeting?.overview?.topics?.map((topic, index) => (
      <Stack direction="row" alignItems="center" key={`${topic.title}-${index}`}>
        <MeetingTopic onClick={() => onTimeClicked(topic.startTime ?? 0)} color={palette.blue[100]}>
          ({getHoursAndMinutesFromNumberOfSeconds(topic.startTime ?? 0)} -
        </MeetingTopic>
        <MeetingTopic onClick={() => onTimeClicked(topic.endTime ?? 0)} color={palette.blue[100]}>
          {getHoursAndMinutesFromNumberOfSeconds(topic.endTime ?? 0)}) -{' '}
        </MeetingTopic>
        <MeetingTopic>{topic.title}</MeetingTopic>
      </Stack>
    ))}
  </Stack>
);

export default MeetingTopics;
